/**
 * Contract Routes
 *
 * Route definitions for the contracts module.
 */

import { lazy } from 'react';

const ContractManagement = lazy(() => import('@/pages/contracts/ContractManagement'));
const ContractDetailView = lazy(() => import('@/pages/contracts/ContractDetailView'));

export const contractRoutes = [
    {
        path: 'contracts',
        element: <ContractManagement />,
    },
    {
        path: 'contracts/:id',
        element: <ContractDetailView />,
        children: [
            { index: true, element: <ContractDetailView /> },
            { path: 'overview', element: <ContractDetailView /> },
            { path: 'rents', element: <ContractDetailView /> },
            { path: 'bka', element: <ContractDetailView /> },
            { path: 'financial', element: <ContractDetailView /> },
            { path: 'sepa', element: <ContractDetailView /> },
            { path: 'notes', element: <ContractDetailView /> },
        ],
    },
];
